
import React from "react";
import styled from "styled-components";
import webdevelopment from '../Assets/Azharpic1.jpg'

// Main wrapper for the page
const Wrap = styled.div`
width: 100%;
height: auto;
padding:0px;
margin:0px;
box-sizing: border-box;
background-color: #f9f9f9; /* Light background for better readability */
  }
`;

// Container for content
const PageWrapper = styled.div`
  max-width: 900px;
  width: 90%;
  margin: 20px auto;
  padding: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 16px;
  box-sizing: border-box;

  @media (max-width: 1024px) {
    font-size: 15px;
    padding: 18px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 15px;
    line-height: 1.7;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 12px;
    line-height: 1.6;
    text-align: center;
  }
`;

// Page Title
const Title = styled.h1`
  text-align: center;
  margin-bottom: 25px;
  font-size: 2rem;
  background: linear-gradient(90deg, #ff7e5f, #feb47b);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 1.6rem;
  }

  @media (max-width: 480px) {
    font-size: 1.4rem;
  }
`;

// Responsive Image
const MobileAppImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  // border-radius: 10px;
  margin-bottom: 25px;

  @media (max-width: 1024px) {
    max-height: 320px;
  }

  @media (max-width: 768px) {
    max-height: 250px;
  }

  @media (max-width: 480px) {
    max-height: 200px;
    margin-bottom: 20px;
  }
`;

// Paragraph styling


export default function PrivacyPolicy() {
  return (
    <Wrap>
      <MobileAppImage src={webdevelopment} alt='Background' />   
    <PageWrapper>
      <Title>Terms & Conditions</Title>
      <p>
        Welcome to <b>BuyNesta</b>. By accessing our website, you agree to
        the following terms and conditions.
      </p>
      <p>
        <b>Use of Content:</b> All content is for informational purposes only
        and should not be considered professional advice.
      </p>
      <p>
        <b>Affiliate Links:</b> We participate in the Amazon Associates Program.
        When you click links and purchase, we may earn a small commission at no
        extra cost to you.
      </p>
      <p>
        <b>Liability:</b> We are not responsible for product quality,
        availability, or shipping delays. These are handled by Amazon.
      </p>
      <p>
        <b>Changes:</b> We may update these terms anytime without prior notice.
      </p>
    </PageWrapper>
    </Wrap>
  );
}
